import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { AuthModule } from 'shared/auth/auth.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { FormModule } from 'shared/form/form.module';
import { SharedModule } from 'shared/shared.module';


@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      LoginRoutingModule,
      AuthModule,
      ReactiveFormsModule,
      FormsModule,
      FormModule,
      SharedModule,
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent]
})
export class LoginModule {}
